import { useState } from "react";
import { Input, message } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch } from 'react-redux';
import { setUser } from "../../Store/slices/User";
import { LoadingOutlined } from '@ant-design/icons';
import { Flex, Spin } from 'antd';
import useResponsive from "../../hooks/useResponsive";

const Login = () => {
    const { isResponsiveMode, isMobile, isTablet } = useResponsive();
    const [nationalNumber, setNationalNumber] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const API_URL = import.meta.env.VITE_API_URL;
    const handleNationalNumberChange = (event) => {
        let value = event.target.value.replace(/[^0-9]/g, '');

        if (value && !value.startsWith('0')) {
            value = '0' + value;
        }

        if (value.length > 11) {
            value = value.slice(0, 11);
        }

        setNationalNumber(value);
    }

    const validatePhoneNumber = () => {
        if (nationalNumber.length !== 11 || !nationalNumber.startsWith('0')) {
            message.error('Phone number must be 11 digits starting with 0 (e.g., 01234567890)');
            return false;
        }
        return true;
    };


    const handleLogin = async () => {
        if (!validatePhoneNumber()) return;
        setLoading(true);
        const fullNumber = `${nationalNumber}`;

        try {
            const response = await axios.post(`${API_URL}users/signin`, {
                mobileNumber: fullNumber
            });

            const { user } = response.data;
            if (user) {
                dispatch(setUser({ user }));
                message.success('OTP resent successfully');
                message.success(response.data.verificationCode);
                setTimeout(() => {
                    navigate('/otp');
                    setLoading(false);
                }, 1000);

                // message.destroy();
            } else {
                message.error('User data not received from server.');
            }
        } catch (error) {
            console.error(error);
            if (error.response?.data?.message) {
                setLoading(false);
                message.error(error.response.data.message ? error.response.data.message : "Error in Login");
            } else {
                message.error('An error occurred during login.');
            }
        }
    };


    return (
        <div className={`flex flex-col md:flex-row h-[100vh] `}>
            <div
                className="relative flex-1 bg-[#1351CB] flex items-center justify-center p-4 md:p-8 before:absolute before:inset-0 before:z-0"
                style={{
                    position: 'relative',
                    minHeight: '50vh'
                }}
            >
                <div
                    className="absolute inset-0 opacity-80 z-0"
                    style={{
                        backgroundImage: "url('/assets/images/intro.jpg')",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }}
                ></div>
                <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-6 md:p-8 relative z-10">
                    {isResponsiveMode ?
                        <div className="flex justify-center items-center mb-4">
                            <img
                                src="/assets/images/CompanyLogo.svg"
                                alt="Company Logo"
                                className="w-[50%] h-auto object-contain"
                            />
                        </div> : ""}
                    <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-[#1351CB] text-center">Login</h2>
                    <div className="flex flex-col gap-3 md:gap-4">
                        <div>
                            <label className="block text-gray-700 mb-2 text-sm md:text-base">Phone Number:</label>
                            <div className="flex items-center gap-2">
                                <span className="bg-gray-100 px-2 md:px-3 py-2 rounded-l-md text-sm md:text-base">+20</span>
                                <Input
                                    maxLength={11}
                                    className="rounded-md outline-none px-2 md:px-3 py-2 flex-1 text-sm md:text-base"
                                    type="tel"
                                    value={nationalNumber}
                                    onChange={handleNationalNumberChange}
                                    placeholder="01234567890"
                                />
                            </div>
                        </div>
                        <button
                            className="w-full bg-[#1351CB] hover:bg-[#1142a8] text-white font-bold py-2 px-4 rounded-md transition-colors text-sm md:text-base"
                            onClick={handleLogin}
                        >
                            {loading ? (
                                <Spin indicator={<LoadingOutlined spin />} />
                            ) : (
                                "Send OTP"
                            )}
                        </button>
                    </div>
                </div>
            </div>

            <div className={`flex-1 bg-white flex items-center justify-center p-4 md:p-8 ${isResponsiveMode ? 'hidden' : ''}`}>
                <div className="max-w-[80%] md:max-w-[50%] w-full">
                    <img
                        src="/assets/images/CompanyLogo.svg"
                        alt="Company Logo"
                        className="w-full h-auto object-contain"
                    />
                </div>
            </div>
        </div>
    );
};

export default Login;
